import { useState } from 'react'
import { Popover } from '@mantine/core'

export default function DashboardDetailPopover({ label, trigger, children, className = '' }) {
    const [opened, setOpened] = useState(false)
    const show = () => setOpened(true)
    const hide = () => setOpened(false)

    return (
        <Popover opened={opened} onChange={setOpened} width={440} position="bottom" withinPortal shadow="sm" radius="md" transitionProps={{ duration: 0 }}>
            <Popover.Target>
                <button type="button" aria-label={label} aria-expanded={opened}
                    onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide} onClick={show}
                    className={`rounded focus-visible:outline-2 focus-visible:outline-blue-500 focus-visible:outline-offset-2 ${className}`}>
                    {trigger}
                </button>
            </Popover.Target>
            <Popover.Dropdown onMouseEnter={show} onMouseLeave={hide} style={{ maxWidth: 'calc(100vw - 24px)', maxHeight: 'min(420px, 70dvh)', overflowY: 'auto' }}>
                {children}
            </Popover.Dropdown>
        </Popover>
    )
}
